var redirectBase = require('./commons/redirect_base');

module.exports = {

  handleCharge: function(charge) {
    redirectBase.handleCharge(charge);
  }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/pingpp-js/src/channels/alipay_qr_lakala.js
// module id = +xX7
// module chunks = 5